import { useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import "../styles/Login.css"

import Logo from "../components/Logo";

import UserService from "../services/UserService";

function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [emailError, setEmailError] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const navigate = useNavigate();
	
	const login = (e) => {
		e.preventDefault();
		setEmailError("");
		setPasswordError("");
		if (!email.trim()) {
			setEmailError("Debe ingresar un correo");
			return;
		}
		if (!password.trim()) {
			setPasswordError("Debe ingresar un constrase&ntilde;a");
			return;
		}
		const currentUser =  { email, password}
		UserService.login(currentUser)
		.then( (result) => { 				
			toast.success("Bienvenido!");
			navigate("/tickets");
		})
		.catch( (e) => {
			toast.error(e.error);
		})
	}
	
	return (
		<div className="Login vh-100 h-100 d-flex justify-content-center align-items-bottom">
			<Container fluid>
				<Row className="justify-content-center align-items-center vh-100 h-100">
					<Col xs={12} md={12} lg={6} className="bg-light p-4 text-center vh-100 h-100 border">
						<Logo />

						<br />
						
						<Form className="mt-4">
							<h2 className="my-4 left text-primary">Buen d&iacute;a</h2>
							
							<div style={{marginTop: "2em"}}>
								<FloatingLabel controlId="floatingEmail" label="Correo" className="my-4">
									<Form.Control type="email" placeholder="Correo" onChange={(e) => {setEmail(e.target.value)} } />
								</FloatingLabel>
								<p className="text-info position-absolute">{emailError}</p>
							</div>
							
							<div style={{marginTop: "5em"}}>
								<FloatingLabel controlId="floatingEmail" label="Contrase&ntilde;a" className="my-4">
									<Form.Control type="password" placeholder="Contrase&ntilde;a" onChange={(e) => {setPassword(e.target.value)} }  />
								</FloatingLabel>
								<p className="text-info position-absolute">{passwordError}</p>
							</div>
							
							<div style={{marginTop: "3em"}}>
								<a href="/remember" className="nav-link text-primary m-4" >&iquest;Olvidaste tu contrase&ntilde;a?</a>
							</div>
							
							<Button variant="primary" type="submit" className="mb-4 p-3 text-white col-12" onClick={login}>
								INGRESAR
							</Button>

							<div>
								<input type="checkbox" className="border border-primary rounded" /> Recu&eacute;rdame
							</div>

						</Form>

						<a href="/signup" className="text-decoration-none text-primary fixed-bottom mb-4" >CREAR UNA CUENTA</a>
						
					</Col>
				</Row>
			</Container>		
		</div>
	);
}

export default Login;
